(function () {

  document.querySelectorAll('.accordion .accordion-header.toggle')
    .forEach((accordion) => {
      accordion.addEventListener('click', (e) => {
        e.target.parentNode.classList.toggle('is-active')
      })
    })

})()



// WEBPACK FOOTER //
// ./scripts/lib/accordions.js